// extracted by mini-css-extract-plugin
export default {"root":"cj7Qut","button":"vYpjY1","lightOrange":"m4vFm9","red":"NQ4WDX"};